export const RequiredMarker = () => <span className="text-red-500 ml-0.5">*</span>;
